import { AdminStatus } from "src/types/adminStatus";
import { Rule } from "src/types/rule";
import { User } from "src/types/user";

import { AlertValidationDecision } from "./alert";
import { CaseSummary } from "./case";

export type ShortScenario = {
  id: string;
  name: string;
  code: string;
  description: string;
  threshold: number;
  adminStatus: AdminStatus;
  rules: ScenarioRule[];
  hasDraftVersion: boolean;
  activeVersion: ScenarioVersionWithRules;
  caseType: {
    code: string;
    name: string;
  };
};

export type FullScenario = ShortScenario & {
  draftVersion: ScenarioVersionWithRules | null;
  archivedVersions: ScenarioVersionWithRules[];
};

export type EmptyScenarioRule = {
  createdAt: Date;
  score: number;
  rule: null;
  createdBy: User;
};

export type DefinedScenarioRule = {
  createdAt: Date;
  score: number;
  rule: Rule;
  createdBy: User;
};

export type ScenarioRule = EmptyScenarioRule | DefinedScenarioRule;

export type ScenarioVersion = {
  id: string;
  name: string;
  description: string | null;
  threshold: number;
  adminStatus: AdminStatus;
  activatedAt: Date | null;
  archivedAt: Date | null;
  status: string;
  scenario: {
    id: string;
    caseTypeCode: string;
    name: string;
  } | null;
};

export type ScenarioVersionWithRules = ScenarioVersion & {
  rules: ScenarioRule[];
};

export const isDefinedScenarioRule = (rule: ScenarioRule): rule is DefinedScenarioRule => {
  return rule.rule !== null;
};

export type ScenarioExecutionMode = "batch" | "individual";

export type RuleExecutionResult = {
  id: string;
  ruleScore: number;
  rule: Rule | null;
};

export type ScenarioExecutionResult = {
  id: string;
  globalScore: number;
  date: Date;
  mode: ScenarioExecutionMode;
  scenarioVersion: ScenarioVersion | null;
  alert: {
    id: string;
    adminStatus: AdminStatus;
    decision: AlertValidationDecision | null;
  } | null;
  triggeredBy: User;
  ruleExecutionDetails: RuleExecutionResult[];
};

export type ScenarioExecutionResultWithCase = ScenarioExecutionResult & {
  creationCase: CaseSummary | null;
  currentCase: CaseSummary | null;
};
